module.exports = __webpack_public_path__ + "img/app01.d792b64c.png";